import $ from 'jquery';

class LocalData {
    setItem(name, data) {
        const storageData = JSON.stringify({
            timestamp: Date.now(),
            data,
        });

        localStorage.setItem(name, storageData);
    }

    getItem(name) {
        const storageData = JSON.parse(localStorage.getItem(name));

        if (!storageData) {
            return false;
        }

        return storageData.data;
    }

    removeItem(name) {
        localStorage.removeItem(name);
    }
}

export const localData = new LocalData();
